/* eslint-disable eqeqeq */
import style from './Administrator.module.css'
import HeadingText from '../../components/administrator/headingText/HeadingText';
import LinkButton from '../../components/administrator/linkButton/LinkButton';
import * as useJwt  from '../../auth/jwt/useJwt.js';

const App = () => {
    const menuPatternData = JSON.parse(useJwt.getMenuPatternData());
    const userData = JSON.parse(useJwt.getUserData());
    return (
        <>
		<label className='bodyLabel'>管理業務</label>
		<div className='contentBody'>
            <HeadingText color='#F8C461' title='保管月報' />
            <div className={style.links}>
                {	(menuPatternData['menu_manage_flag_1'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/itemStorageMonthReport' title='品種別保管月報' />
				}
                {	(menuPatternData['menu_manage_flag_2'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/warehouseStorageMonthReport' title='倉庫別保管月報' />
				}
            </div>
            <HeadingText color='#73A776' title='荷主管理' />
            <div className={style.links}>
                {	(menuPatternData['menu_manage_flag_3'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/shipperInOutList' title='荷主別入出庫明細表' />
				}
                {	(menuPatternData['menu_manage_flag_4'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/shipperInOutDailyList' title='荷主別入出庫日計表' />
				}
            </div>
            <HeadingText color='#F8C461' title='倉庫管理' />
            <div className={style.links}>
                {	(menuPatternData['menu_manage_flag_5'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/warehouseInOutList' title='倉庫別入出庫明細表' />
				}
                {	(menuPatternData['menu_manage_flag_6'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/warehouseInOutDailyList' title='倉庫別入出庫日計表' />
				}
            </div>
            <HeadingText color='#F8C461' title='届け先管理' />
            <div className={style.links}>
                {	(menuPatternData['menu_manage_flag_7'] == 1 || userData['sys_role_id'] == 10000) &&
					<LinkButton link='/administrator/destinationOutList' title='届け先出荷集計表' />
				}
            </div>
            </div>
        </>
    );
};

export default App;